import { rem } from 'polished';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import CardPayPic from '../../assets/cardpay.png';
import SporoPayPic from '../../assets/sporopay01.gif';
import TatraPayPic from '../../assets/tatrapay.png';
import VubEplatbyPic from '../../assets/vubeplatby.gif';

const paymentsTypes = [
  { label: 'CardPay', key: 'CardPay' },
  { label: 'TatraBanka', key: 'TatraPay' },
  { label: 'VÚB Banka', key: 'VubPlatby' },
  { label: 'SLSP', key: 'SporoPay' },
];

const Wrapper = styled.div``;

const Label = styled.label`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${rem(5)} 0;
  justify-content: center;
  cursor: pointer;
  &:hover {
    background: #d8d8d8;
  }
`;

const Img = styled.img`
  width: 90px;
`;

const Name = styled.div`
  width: 120px;
  margin: 0 ${rem(10)};
`;

const Input = styled.input``;

class PaymentTypes extends Component {
  render() {
    const { value, onChange } = this.props;
    const bankPicMap = {
      TatraPay: TatraPayPic,
      VubPlatby: VubEplatbyPic,
      CardPay: CardPayPic,
      SporoPay: SporoPayPic,
    };

    return (
      <Wrapper>
        {paymentsTypes.map(type => (
          <Label key={type.key}>
            <Input
              type="radio"
              naem="payment-type"
              value={type.key}
              checked={value === type.key}
              onChange={e => {
                if (e.target.checked) {
                  onChange(type.key);
                }
              }}
            />
            <Name>{type.label}</Name>
            <Img src={bankPicMap[type.key]} />
          </Label>
        ))}
      </Wrapper>
    );
  }
}

PaymentTypes.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

PaymentTypes.defaultProps = {
  value: null,
};

export default PaymentTypes;



// WEBPACK FOOTER //
// ./src/components/PaymentTypes/index.js